export default {
    init: ($) => {

        console.info('nav.js: init');

        $('#masthead .user-area').click(()=>{
            $('body').addClass('menu-open');
        });

        $('.ua-menu-overlay').click(()=>{
            $('body').removeClass('menu-open mini-cart-open');
        });

        // menu mobile
        try {
            window.mslider = new Slideout({
                'panel': document.getElementById('page'),
                'menu': document.getElementById('menu'),
                'padding': 256,
                'tolerance': 70,
                touch: false
            });
        }catch (e) {}

        $('.mobile-menu-archor, .mobile-menu-overlay').click((e)=>{
            e.preventDefault();
            window.mslider.toggle();
        });

        // mini cart open

        $('.sacola-click, .site-header-cart .cart-contents').on('click',(e)=>{
            if ( $('body').is('.woocommerce-cart')|| $('body').is('.woocommerce-checkout') ){
                return true;
            }else{
                e.preventDefault();
                $('body').addClass('mini-cart-open');
            }
        })
    }
}